$(document).ready(function() {
	

$('.TestimonialSlider').slick({
	 infinite: true,
	  autoplay: true,
  	  autoplaySpeed: 2000,
  	  arrows: true,
  	  fade: true
});

$("input").attr("autocomplete","off");

$('.datetimepicker').datetimepicker({
	minDate: "today",
    minTime:'09:00',
    maxTime:'21:00',
    onGenerate:function( ct ){
    jQuery(this).find('.xdsoft_date.xdsoft_weekend')
      .addClass('xdsoft_disabled');
    }
});

//Accordion
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}


AOS.init();

//popup
// $("#Cookiespopup").delay(3000).fadeIn(500);

// $('#Cookiespopup .CookieButton').click(function(e) {
//     e.preventDefault();
//     $('#Cookiespopup').animate({
//         'visibility' : 'hidden',
//         'opacity' : 0
//     })
// })

    if(localStorage.getItem('popState') != 'shown'){
        $("#Cookiespopup").delay(2000).fadeIn();
        localStorage.setItem('popState','shown')
    }

    $('#CloseCookiesMsg, .CookieButton').click(function(e) // You are clicking the close button
    {
        $('#Cookiespopup').fadeOut(); // Now the pop up is hiden.
    });

// $("#FooterCRMPopup").delay(10000).fadeOut(500);


$('#FooterCRMPopup .ClosePopup').click(function(e) {
    e.preventDefault();
    $('#FooterCRMPopup').animate({
        'visibility' : 'hidden',
        'opacity' : 0
    })
})

	// Get the form.
    // var form = $('.ContactforElectric');
    // var formMessages = $('.form-messages');
    // var formData = $(form).serialize();
    
    // $.ajax({
    //     type: 'POST',
    //     url: $(form).attr('action'),
    //     data: formData
    // })
    // .done(function(response) {
    //     $(formMessages).removeClass('error');
    //     $(formMessages).addClass('success');
    
    //     $(formMessages).text(response);
    
    //     $('.bill-name').val('');
    //     $('.bill-mobile').val('');
    //     $('.bill-email').val('');
    //     $('.bill-date').val('');
    // })
    // .fail(function(data) {
    //     $(formMessages).removeClass('success');
    //     $(formMessages).addClass('error');
    
    //     if (data.responseText !== '') {
    //         $(formMessages).text(data.responseText);
    //     } else {
    //         $(formMessages).text('Oops! An error occured and your message could not be sent.');
    //     }
    // });



})


//# sourceMappingURL=data:application/json;charset=utf8;base64,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
